export enum FiltersActionTypes {
  DATA_SET = "FILTERS/DATA_SET",
  CLEAR_DATA = "FILTERS/CLEAR_DATA",
}
